import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AlertTriangle, CreditCard, X } from 'lucide-react';
import { formatMoney } from '../utils/locale';

export default function BillingRestrictionModal() {
  const [restriction, setRestriction] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const show = (event) => setRestriction(event.detail || {});
    window.addEventListener('coachhub-billing-restriction', show);
    return () => window.removeEventListener('coachhub-billing-restriction', show);
  }, []);

  useEffect(() => {
    if (restriction?.code === 'billing_blocked' && location.pathname !== '/institute-panel/billing') {
      navigate('/institute-panel/billing', { replace: true });
    }
  }, [restriction, location.pathname, navigate]);

  // On the billing page itself the page shows the amount and Pay button; an overlay there
  // (re-opened by every other blocked request on the page) would only hide them
  if (!restriction || location.pathname === '/institute-panel/billing') return null;
  const amount = Number(restriction.amount || restriction.balance_due || restriction.total_payable || 0);
  const close = () => setRestriction(null);

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-slate-950/60 p-4" role="presentation" data-testid="billing-restriction-modal">
      <div role="dialog" aria-modal="true" aria-labelledby="billing-restriction-title" className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl dark:bg-slate-900">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-3"><span className="rounded-xl bg-rose-100 p-2 text-rose-600"><AlertTriangle className="h-5 w-5" /></span><h2 id="billing-restriction-title" className="font-outfit text-lg font-bold text-slate-900 dark:text-white">Platform payment due</h2></div>
          <button type="button" aria-label="Close" onClick={close} className="rounded-lg p-1 text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800"><X className="h-4 w-4" /></button>
        </div>
        <p className="mt-4 text-sm text-slate-600 dark:text-slate-300">{restriction.message || 'Please clear the outstanding platform invoice to continue.'}</p>
        {amount > 0 && <p className="mt-3 font-outfit text-2xl font-extrabold text-slate-900 dark:text-white">{formatMoney(amount)}</p>}
        <button type="button" onClick={() => { close(); navigate('/institute-panel/billing'); }} className="mt-5 inline-flex h-11 w-full items-center justify-center gap-2 rounded-xl bg-indigo-600 font-bold text-white">
          <CreditCard className="h-4 w-4" /> Open billing and pay
        </button>
      </div>
    </div>
  );
}
